var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      attrs: { form: _vm.form, rules: _vm.rules, "label-width": "120px" },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      _c("BjDivider", [_vm._v("基本信息")]),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "名称", prop: "tenantName" } },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: "请输入",
                  clearable: "",
                },
                model: {
                  value: _vm.form.tenantName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "tenantName", $$v)
                  },
                  expression: "form.tenantName",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c("BjFormItemCode", {
            attrs: {
              label: "编码",
              prop: "tenantNum",
              required: "",
              disabled: _vm.isEdit,
            },
            model: {
              value: _vm.form.tenantNum,
              callback: function ($$v) {
                _vm.$set(_vm.form, "tenantNum", $$v)
              },
              expression: "form.tenantNum",
            },
          }),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "限制用户数", prop: "limitUserQty" } },
            [
              _c("BjInputNumber", {
                attrs: {
                  placeholder: "请输入",
                  clearable: "",
                  "not-auto-zero": "",
                  min: 0,
                },
                model: {
                  value: _vm.form.limitUserQty,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "limitUserQty", $$v)
                  },
                  expression: "form.limitUserQty",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "有效期起", prop: "startDateActive" } },
            [
              _c("el-date-picker", {
                staticClass: "full-width",
                attrs: {
                  type: "date",
                  "value-format": "yyyy-MM-dd",
                  placeholder: "请选择",
                },
                on: { change: _vm.handleChangeStartTime },
                model: {
                  value: _vm.form.startDateActive,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "startDateActive", $$v)
                  },
                  expression: "form.startDateActive",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "有效期至", prop: "endDateActive" } },
            [
              _c("el-date-picker", {
                staticClass: "full-width",
                attrs: {
                  type: "date",
                  "value-format": "yyyy-MM-dd",
                  placeholder: "请选择",
                  "picker-options": _vm.$disabledPickerDate(
                    _vm.form.startDateActive
                  ),
                },
                model: {
                  value: _vm.form.endDateActive,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "endDateActive", $$v)
                  },
                  expression: "form.endDateActive",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "启用", prop: "enabledFlag" } },
            [
              _c("el-switch", {
                attrs: { "active-value": 1, "inactive-value": 0 },
                model: {
                  value: _vm.form.enabledFlag,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "enabledFlag", $$v)
                  },
                  expression: "form.enabledFlag",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }